__turbopack_context__.v({
  "backdrop": "DropDown-module-scss-module__U-2t1a__backdrop",
  "backdropAboveDialog": "DropDown-module-scss-module__U-2t1a__backdropAboveDialog",
  "caret": "DropDown-module-scss-module__U-2t1a__caret",
  "closeButton": "DropDown-module-scss-module__U-2t1a__closeButton",
  "dropdownCloseDesktop": "DropDown-module-scss-module__U-2t1a__dropdownCloseDesktop",
  "dropdownCloseMobile": "DropDown-module-scss-module__U-2t1a__dropdownCloseMobile",
  "dropdownOpenDesktop": "DropDown-module-scss-module__U-2t1a__dropdownOpenDesktop",
  "dropdownOpenMobile": "DropDown-module-scss-module__U-2t1a__dropdownOpenMobile",
  "fadeIn": "DropDown-module-scss-module__U-2t1a__fadeIn",
  "fadeOut": "DropDown-module-scss-module__U-2t1a__fadeOut",
  "mobileHeader": "DropDown-module-scss-module__U-2t1a__mobileHeader",
  "popup": "DropDown-module-scss-module__U-2t1a__popup",
  "popupDesktop": "DropDown-module-scss-module__U-2t1a__popupDesktop",
  "popupMatchAnchorDesktop": "DropDown-module-scss-module__U-2t1a__popupMatchAnchorDesktop",
  "popupMobile": "DropDown-module-scss-module__U-2t1a__popupMobile",
  "popupWideScrollGutter": "DropDown-module-scss-module__U-2t1a__popupWideScrollGutter",
  "positioner": "DropDown-module-scss-module__U-2t1a__positioner",
  "positionerAboveDialog": "DropDown-module-scss-module__U-2t1a__positionerAboveDialog",
  "positionerMatchAnchor": "DropDown-module-scss-module__U-2t1a__positionerMatchAnchor",
  "positionerMobile": "DropDown-module-scss-module__U-2t1a__positionerMobile",
  "scrollRegion": "DropDown-module-scss-module__U-2t1a__scrollRegion",
  "scrollRegionWideGutter": "DropDown-module-scss-module__U-2t1a__scrollRegionWideGutter",
  "trigger": "DropDown-module-scss-module__U-2t1a__trigger",
  "triggerLabel": "DropDown-module-scss-module__U-2t1a__triggerLabel",
  "triggerPrimary": "DropDown-module-scss-module__U-2t1a__triggerPrimary",
  "triggerPrimaryMobile": "DropDown-module-scss-module__U-2t1a__triggerPrimaryMobile",
  "triggerPrimaryOpen": "DropDown-module-scss-module__U-2t1a__triggerPrimaryOpen",
  "triggerSecondary": "DropDown-module-scss-module__U-2t1a__triggerSecondary",
  "triggerSecondaryOpen": "DropDown-module-scss-module__U-2t1a__triggerSecondaryOpen",
});
